import { MapPin } from 'lucide-react';
import { getStoreMapUrls } from '@/lib/storeMapUrls';

interface VehicleDetailLocationProps {
  vehicleStore: any;
}

export function VehicleDetailLocation({ vehicleStore }: VehicleDetailLocationProps) {
  const place = vehicleStore?.place;
  const { embedUrl, directionsUrl } = getStoreMapUrls(place);

  if (!place?.address && !embedUrl) return null;

  return (
    <section className="wl6-vd-section">
      <div className="wl6-vd-section__head">
        <p className="wl6-eyebrow">Onde encontrar</p>
        <h2 className="wl6-vd-section__title wl6-h2">Localização</h2>
      </div>

      {place.address && (
        <p className="text-sm text-muted-foreground mb-4 flex items-start gap-2">
          <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
          {place.address}
        </p>
      )}

      {embedUrl && (
        <div className="wl6-vd-map">
          <iframe
            title={`Mapa — ${vehicleStore?.company || 'Loja'}`}
            src={embedUrl}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      )}

      {directionsUrl && (
        <a
          href={directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="wl6-vd-map__link mt-3"
        >
          <MapPin className="h-4 w-4" />
          Como chegar
        </a>
      )}
    </section>
  );
}
